import { render, staticRenderFns } from "./familySchduleTable.vue?vue&type=template&id=180fdabe&scoped=true&"
import script from "./familySchduleTable.vue?vue&type=script&lang=js&"
export * from "./familySchduleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180fdabe",
  null
  
)

export default component.exports